
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/[make]/[model]",
      function () {
        return require("private-next-pages/insights/[make]/[model]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/[make]/[model]"])
      });
    }
  